<template>
  <ToastB
    class="toast"
    v-bind="props"
    :progress
    @resume-timer="resumeTimer"
    @pause-timer="pauseTimer"
    @close="$emit('close', $event)"
  />
</template>

<script setup lang="ts">
import type { ToastProps } from "~/types/schemas/common/Atom/toaster";
import ToastB from "~/components/common/Atom/Toaster/Toast/B.vue";

const emit = defineEmits<{ (e: "close", id: number): void }>();

const props = defineProps<ToastProps>();

let startTime: number;
let timeoutId: NodeJS.Timeout;
let remainingTime: number = props.duration;

const progress = ref(100);
const updateInterval = ref<NodeJS.Timeout | null>(null);

const updateProgress = () => {
  const elapsed = Date.now() - startTime;
  progress.value = 100 - (elapsed / props.duration) * 100;

  if (progress.value <= 0) {
    if (updateInterval.value) {
      clearInterval(updateInterval.value);
    }
  }
};

const pauseTimer = () => {
  clearTimeout(timeoutId);
  if (updateInterval.value) {
    clearInterval(updateInterval.value);
  }
  remainingTime -= Date.now() - startTime;
};

const resumeTimer = () => {
  startTime = Date.now();
  timeoutId = setTimeout(() => emit("close", props.id), remainingTime);

  // Resume progress bar updates
  updateInterval.value = setInterval(updateProgress, 1);
};

onMounted(() => {
  startTime = Date.now();
  timeoutId = setTimeout(() => emit("close", props.id), props.duration);

  // Start progress bar updates
  updateInterval.value = setInterval(updateProgress, 1);
});

onUnmounted(() => {
  clearTimeout(timeoutId);
  if (updateInterval.value) {
    clearInterval(updateInterval.value);
  }
});
</script>

<style>
.toast {
  .loader {
    animation: toast-loader linear;
    animation-fill-mode: forwards;
  }
  &:hover .loader {
    animation-play-state: paused;
  }
}

@keyframes toast-loader {
  0% {
    width: 100%;
  }
  100% {
    width: 0%;
  }
}
</style>
